// Anti-Inflammatory Peptides page: evidence-only cards (no doses, no stack builder).
// Data (peptides, PEPTIDE_GROUPS) and display helpers (CORSuite) come from peptides-data.js.
(function () {
  var state = { group: 'all', search: '', sort: 'anti' };
  var esc = function (s) { return CORSuite.esc(s); };

  function statusPill(p) {
    return '<span class="status-pill status-' + esc(p.group) + '">' + esc(PEPTIDE_GROUPS[p.group] || '') + '</span>';
  }

  function card(p) {
    return '<div class="food-card" data-id="' + esc(p.id) + '">' +
      '<div class="food-header"><h3 class="food-name">' + esc(p.name) + '</h3>' +
      '<button class="btn-secondary view-details-btn" data-id="' + esc(p.id) + '"><i data-lucide="info"></i> Details</button></div>' +
      statusPill(p) +
      '<p class="food-description">' + esc(p.description) + '</p>' +
      '<div class="food-badges"><span class="evidence-badge">' + esc(CORSuite.evText(p, false)) + '</span>' +
      '<span class="safety-badge">' + esc(CORSuite.antiText(p)) + '</span></div>' +
      '<div class="food-meta"><span class="peptide-route">' + esc(p.route) + '</span></div>' +
      '</div>';
  }

  function render() {
    var list = peptides.filter(function (p) {
      var inGroup = state.group === 'all' || p.group === state.group;
      var q = state.search;
      var hay = (p.name + ' ' + p.description + ' ' + (p.evidence.summary || '')).toLowerCase();
      return inGroup && (!q || hay.indexOf(q) !== -1);
    });
    list.sort(function (a, b) {
      if (state.sort === 'name') return a.name.localeCompare(b.name);
      if (state.sort === 'evidence') return (b.evidence.score10 || 0) - (a.evidence.score10 || 0);
      return (b.antiInflammatory10 || 0) - (a.antiInflammatory10 || 0) || (b.evidence.score10 || 0) - (a.evidence.score10 || 0);
    });
    var el = document.getElementById('peptides-container');
    el.innerHTML = list.length ? list.map(card).join('') : '<p>No peptides match.</p>';
    if (window.lucide) window.lucide.createIcons();
  }

  function openModal(id) {
    var p = peptides.find(function (x) { return x.id === id; });
    if (!p) return;
    var body = document.querySelector('#peptide-modal .modal-body');
    body.innerHTML =
      '<div class="modal-header"><h2>' + esc(p.name) + '</h2>' +
      '<div class="modal-badges"><span class="evidence-badge">' + esc(CORSuite.evText(p, true)) + '</span>' +
      '<span class="safety-badge">' + esc(CORSuite.antiText(p)) + '</span></div></div>' +
      '<div class="peptide-status-box">' + statusPill(p) + '<br><strong>Status:</strong> ' + esc(p.status) +
      '<br><strong>How it is taken:</strong> ' + esc(p.route) + '</div>' +
      CORSuite.section(p) +
      '<div class="modal-section"><p class="cor-evidence-note">No doses are listed for peptides. Prescription drugs should ' +
      'only be used under a doctor\'s care; research-use products are not approved for people.</p></div>';
    document.getElementById('peptide-modal').classList.remove('hidden');
    if (window.lucide) window.lucide.createIcons();
  }

  function closeModal() { document.getElementById('peptide-modal').classList.add('hidden'); }

  document.addEventListener('DOMContentLoaded', function () {
    document.getElementById('peptide-search').addEventListener('input', function (e) { state.search = e.target.value.toLowerCase(); render(); });
    document.getElementById('peptide-sort').addEventListener('change', function (e) { state.sort = e.target.value; render(); });
    document.querySelectorAll('.category-chip[data-group]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        document.querySelectorAll('.category-chip[data-group]').forEach(function (c) { c.classList.remove('active'); });
        chip.classList.add('active'); state.group = chip.dataset.group; render();
      });
    });
    document.getElementById('peptides-container').addEventListener('click', function (e) {
      var btn = e.target.closest('.view-details-btn, .food-card');
      if (btn) openModal(btn.dataset.id || btn.closest('.food-card').dataset.id);
    });
    document.querySelector('#peptide-modal .modal-close').addEventListener('click', closeModal);
    document.getElementById('peptide-modal').addEventListener('click', function (e) { if (e.target.id === 'peptide-modal') closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    render();
  });
})();
